import React from "react";
import timeFunction from "../../functions/getTime";

/**
 * Horizontal news item — design/new card.png (top two rows)
 *   normal : 151x130 thumbnail, black title, #4B4F55 body, #919191 date
 *   hover  : title turns #FF4713
 *   No frame / no shadow — the item sits directly on the page background.
 */
export default function HorizontalCard(props) {
  const small = props.size === "small";

  const openLink = () => {
    if (props.page === "newsAndActivity/news" || props.page === "article")
      window.open(`/${props.lang}/${props.page}/${props.data.slug}`, "_self");
  };

  const thumbUrl = props.appointment
    ? props.data &&
      props.data.image &&
      props.data.image.image &&
      props.data.image.image[0]
      ? `${process.env.REACT_APP_API_URL}${props.data.image.image[0].url}`
      : null
    : props.data && props.data.image && props.data.image[0]
    ? `${process.env.REACT_APP_API_URL}${props.data.image[0].url}`
    : null;

  return (
    <div
      className="group flex gap-[16px] cursor-pointer"
      onClick={() => !props.appointment && openLink()}
    >
      <span
        className={
          `shrink-0 rounded-[8px] bg-lightGray !bg-cover !bg-center ` +
          (small ? "w-[120px] h-[104px]" : "w-[151px] h-[130px]")
        }
        style={
          thumbUrl
            ? { background: `url(${thumbUrl}) center / cover no-repeat` }
            : { background: `#D9D9D9` }
        }
      />

      <div className="flex-1 min-w-0 flex flex-col">
        <p
          className={
            `text-left font-normal text-black group-hover:text-brand transition-colors duration-200 line-clamp-2 ` +
            (small
              ? "text-body leading-tight"
              : "text-lead leading-tight")
          }
        >
          {props.lang === "th"
            ? props.data.title.detail_TH
            : props.data.title.detail_EN}
        </p>

        {props.appointment !== true && props.data ? (
          <p className="text-left font-normal text-slateGray line-clamp-2 text-body leading-snug">
            {props.lang === "th"
              ? props.data?.description?.detail_TH
              : props.data?.description?.detail_EN}
          </p>
        ) : (
          <p className="text-left font-normal text-slateGray line-clamp-2 text-body leading-snug">
            <span className="font-bold">
              {props.lang === "th" ? "รายละเอียด" : "Detail"} :
            </span>{" "}
            {props.lang === "th"
              ? props.data?.content?.detail_TH
              : props.data?.content?.detail_EN}
          </p>
        )}

        {props.noDate !== true && (
          <p className="text-left text-metaGray text-meta">
            {timeFunction.getTime(props.data.publishedAt, props.lang)}
          </p>
        )}
      </div>
    </div>
  );
}
